{
  "fr": {
    "groupJoinForm": {
      "label": "Code d'activation à 8 chiffres",
      "placeholder": "Entrer le code",
      "submit": "Activer la licence",
      "error": "Le code saisi est invalide.",
      "invalidFormat": "Veuillez entrer un code valide à 8 chiffres.",
      "alreadyMember": "Vous êtes déjà membre de ce groupe."
    }
  }
}
